import React, { Fragment } from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
export function ProblemSection() {
  return <Section background="ivory" className="border-t border-purple-200" data-id="element-342" data-mp="2ltwbnrwx0iwk">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-start" data-id="element-343" data-mp="30i99kufkcbtp">
        <div className="lg:sticky lg:top-32" data-id="element-344" data-mp="2vpzb2q0du3ft">
          <FadeIn data-id="element-345" data-mp="2vp6eghv50ube">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-charcoal leading-tight mb-6" data-id="element-346" data-mp="2voo7aq6xsvop">
              Wellness Shouldn't Be{' '}
              <span className="italic text-charcoal/60" data-id="element-347" data-mp="35f95icip7y73">Fragmented</span>
            </h2>
            <p className="text-lg text-charcoal/70 leading-relaxed max-w-md" data-id="element-348" data-mp="3jgbuax12vmlp">
              Women today navigate a disjointed and often inaccessible wellness
              system — one that lacks personalization, trust, and continuity of
              care. This is not just inefficiency — it's a systemic failure in
              how women experience care.
            </p>
          </FadeIn>
        </div>

        <div className="space-y-12" data-id="element-349" data-mp="je6dotpfma6a">
          <FadeIn delay={200} data-id="element-350" data-mp="jb0nfb52h28z">
            <div className="pl-6 border-l border-purple-300/50" data-id="element-351" data-mp="obyekd8216mm">
              <div className="text-5xl md:text-6xl font-serif text-charcoal mb-2" data-id="element-352" data-mp="oa3t8xsvfci0">
                16<span className="text-purple-700" data-id="element-353" data-mp="sc8hti4gpixs">+</span>
              </div>
              <div className="text-sm uppercase tracking-widest text-charcoal/50 font-medium mb-2" data-id="element-354" data-mp="x5jsjuceajuz">
                Weeks
              </div>
              <p className="text-lg text-charcoal/80" data-id="element-355" data-mp="125pi94z3twaf">
                Wait times for specialized services in Canada, leaving critical
                needs unmet.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={400} data-id="element-356" data-mp="1g3e34ct693fh">
            <div className="pl-6 border-l border-purple-300/50" data-id="element-357" data-mp="1g2cnrw54hury">
              <div className="text-5xl md:text-6xl font-serif text-charcoal mb-2" data-id="element-358" data-mp="3dt5lspwptkoo">
                98<span className="text-purple-700" data-id="element-359" data-mp="3dvibjp8pszca">%</span>
              </div>
              <div className="text-sm uppercase tracking-widest text-charcoal/50 font-medium mb-2" data-id="element-360" data-mp="3hv0w2jwmj8el">
                Misdiagnosis
              </div>
              <p className="text-lg text-charcoal/80" data-id="element-361" data-mp="k1pczl0pnmjj">
                Rates in certain psychiatric conditions, highlighting a lack of
                tailored clinical understanding.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={600} data-id="element-362" data-mp="txseqprnhj5y">
            <div className="pl-6 border-l border-purple-300/40" data-id="element-363" data-mp="u1pyndm1yeqw">
              <div className="text-3xl md:text-4xl font-serif text-charcoal mb-2" data-id="element-364" data-mp="17xjyl74ultrv">
                Majority
              </div>
              <div className="text-sm uppercase tracking-widest text-charcoal/50 font-medium mb-2" data-id="element-365" data-mp="12y7daqtmkure">
                Underserved
              </div>
              <p className="text-lg text-charcoal/80" data-id="element-366" data-mp="1cqwaqhscc83q">
                Of women with mood disorders remain without adequate, continuous
                support.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </Section>;
}